import React from 'react';
import ReactDOM from 'react-dom';
import App from './main/app/app';
import './styles/app.css';

ReactDOM.render(<App/>, document.getElementById('root'));
